export enum DNATypeEnum {
    PCR = 0,
    PLASMID,
}
